import styled from "@emotion/styled";
import { Button } from "@material-ui/core";

export const SupportButton = styled(Button)`
  font-size: 24px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  width: 300px;
  background-color: transparent;
`;
